import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class GroupWorkbookPage extends DTO {
  status: common.GroupScoringStatus
  readonly workbookPage: {
    id: number
    workbookId: number
    page: number
    title: string
    imageUrl?: string
  }
  studentWorkbookProgresses: res.GroupWorkbookProgress['studentWorkbookProgresses']

  get pageNum() {
    return this.workbookPage.page
  }

  get pageId() {
    return this.workbookPage.id
  }

  constructor(data: res.GroupWorkbookProgress) {
    super()
    this.status = data.status
    this.workbookPage = data.workbookPage
    this.studentWorkbookProgresses = data.studentWorkbookProgresses

    makeObservable(this, { status: observable, pageId: computed, pageNum: computed })
  }

  get progressIdList() {
    return this.studentWorkbookProgresses.map((progress) => progress.id)
  }
}
